/**
 * Zod runtime schemas that mirror the shared type definitions in
 * packages/shared-types/src/ai-tools.types.ts.
 *
 * Kept here because only the frontend needs runtime parsing and it
 * owns the zod dependency.
 */

import type { StartExpertChatOutput } from "@shared/types"
import { z } from "zod"

export const startExpertChatSuccessSchema = z.object({
  conversationId: z.string(),
  deepLink: z.string(),
  name: z.string(),
})

export const startExpertChatFailureSchema = z.object({
  conversationId: z.null(),
  error: z.string(),
})

export const startExpertChatOutputSchema: z.ZodType<StartExpertChatOutput> = z.union([
  startExpertChatSuccessSchema,
  startExpertChatFailureSchema,
])
